<template>
    <div class="template info-con" @click="hideMore">
        <div class="tmp-title nav-title">
            <div class="tt-left">
                <h2>
                    企业素材
                    <action-tips>
                        <template slot="tips">
                            <p>
                                可以上传jpg、png格式的图片，作为创意素材共享给团队成员使用。
                            </p>
                            <p>同时可以创建文件夹，将图片素材按需分类，实现高效管理。</p>
                        </template>
                    </action-tips>
                </h2>
                <el-select v-model="selectVal" class="material-select" placeholder="请选择" @change="changeSelect">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #7966ff; padding-left: 8px" :class="item.icon"></span>
                    </el-option>
                </el-select>
            </div>
            <div class="tt-right" v-if="loginInfo.current_team_role !== 4">
                <el-button class="new-folder" @click="newFolder">新建文件夹</el-button>
                <el-button type="primary" @click="showuploaddialog">上传素材</el-button>
            </div>
        </div>
        <div class="tmp-con">
            <ActionBread :breadList="breadList" />
            <div class="template-list">
                <ul class="folder-ul">
                    <template v-for="item in templateInfo.style_directory">
                        <ActionFolder :item="item" :key="item.id" />
                    </template>
                </ul>
                <ul class="image-ul" v-if="templateInfo && templateInfo.styles">
                    <template v-for="item in templateInfo.styles.data">
                        <ActionImage :key="item.id" :item="item" />
                    </template>
                </ul>

                <Pagination v-if="Pagination.total > Pagination.page_size" @handleCurrentChange="handleCurrentChange" :Pagination="Pagination" />
            </div>
        </div>

        <RenameDialog ref="renameDialog" :title="moreInfo && moreInfo.id ? '重命名' : '新建文件夹'" @submit="editFolder" />

        <RemoveDialog :title="
        moreInfo && Object.keys(moreInfo).includes('url')
          ? '是否确认删除该素材'
          : '是否确认删除该文件夹'
      " @remove="removeFolder"/>
        <MoveFolder @submit="moveSubmit" ref="move"/>

        <!--过期弹出框-->
        <expireTeamDialog />

        <!-- 上传企业素材弹框 -->
        <el-dialog class="upload-localfont-dialog" title="上传企业素材" :visible.sync="uploadLocalVisiable" :close-on-click-modal="false" center @close="stopUpload" ref="uploadfontdialog" @open="openuploadtool">
            <!-- 上传按钮以及上传中的文件列表 -->
            <ul class="upload-list-box">
                <li v-show="showuploadtool || showFileList.length == 0">
                    <div id="upload-section">
                        <file-upload multiple class="upload-component" ref="upload" v-model="showFileList" :input-id="name" :post-action="postAction" :accept="accept" :headers="headers" :data="uploaddata" :thread="1" @input-filter="inputFilter" @input-file="inputFile">
                            <i class="el-icon-plus"></i>
                        </file-upload>
                    </div>
                </li>

                <li v-for="(file, i) in showFileList" :key="i" class="fileitem">
                    <!-- 等待上传  可展示删除按钮 -->
                    <template v-if="file.upload_step == 1">
                        <div class="state-box state-box-border">
                            <img :src="file.preview_url" alt="" />
                            <div class="upload-listitem-actions upload-listitem-actions-tip">
                                <el-progress :percentage="file.progress" :color="progresscolor" stroke-width="3" :show-text="false"></el-progress>
                            </div>
                            <!--  <div
                :class="{
                  'upload-listitem-actions': file.maskshow,
                  'upload-listitem-actions-tip': file.maskshow,
                }"
              >

              </div> -->
                        </div>
                        <!-- 展示字体名字 -->
                        <div class="upload-lsititem-title">{{ file.name }}</div>
                    </template>

                    <!-- 上传中  展示进度条 -->
                    <template v-if="file.upload_step == 2">
                        <div class="state-box state-box-border" @mouseenter="fontmouseover(file, i)" @mouseleave="fontmouseout(file, i)">
                            <img :src="file.preview_url" alt="" />
                            <div class="upload-listitem-actions">
                                <el-progress :percentage="file.progress" :color="progresscolor" stroke-width="3" :show-text="false"></el-progress>
                            </div>
                        </div>
                        <!-- 展示字体名字 -->
                        <div class="upload-lsititem-title">{{ file.name }}</div>
                    </template>

                    <!-- 上传结束  -->
                    <template v-if="file.upload_step == 3">
                        <!-- 实际接口请求成功展示状态 -->
                        <template v-if="file.upload_status == 4">
                            <div class="state-box state-box-border">
                                <img class="img_path" :src="file.preview_url" alt="" />
                            </div>
                            <!-- 展示字体名字 -->
                            <div class="upload-lsititem-title">{{ file.name }}</div>
                        </template>

                        <template v-if="file.upload_status == 3 || file.upload_status == 5">
                            <div class="state-box state-box-border" @mouseenter="fontmouseover(file, i)" @mouseleave="fontmouseout(file, i)">
                                <img :src="file.preview_url" alt="" />
                                <div class="upload-listitem-actions upload-listitem-actions-tip">
                                    <template>
                                        <div class="upload-fail-tiptext">上传失败</div>
                                        <div class="upload-fail-tiptext">
                                            {{ file.response.error || "接口出错" }}
                                        </div>
                                        <img src="@/assets/image/upload_error.svg" alt="" class="upload-delete-icon" @click="deluploadfile(file)" />
                                        <!--  <span class="iconfont icon-close2 upload-delete-icon" @click="deluploadfile(file)"></span> -->
                                    </template>
                                </div>
                            </div>
                        </template>
                    </template>
                </li>
            </ul>

            <div class="btn-wrap" slot="footer">
                <el-button type="default" @click="stopUpload">取消</el-button>

                <el-button type="primary" :class="{ 'is-disabled': !uploaded }" @click="uploadLocalconfirm" :disabled="!uploaded">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Template, Materials } from "@/config/axios/new_api";
import Index from "@/config/mixin/index.js";
import RenameDialog from "@/components/dialog/renameDialog.vue";
import RemoveDialog from "@/components/dialog/removeDialog.vue";
import MoveFolder from "@/components/dialog/moveFolder.vue";
import FileUpload from "isheji-upload-component/src";
import ActionFolder from "@/components/actionContent/folder";
import ActionImage from "@/components/actionContent/image";
import ActionTips from "@/components/actionContent/titleTips";
import ActionBread from "@/components/actionContent/bread";
import tokenFunc from "@/config/static/token";
export default {
    components: {
        RenameDialog,
        RemoveDialog,
        MoveFolder,
        FileUpload,
        ActionFolder,
        ActionImage,
        ActionTips,
        ActionBread,
    },
    mixins: [Index],
    data() {
        return {
            breadList: [],
            templateInfo: {},
            moreInfo: null,
            moreStatus: false,
            renameStatus: false,
            moveDialogStatus: false,
            removeDialogStatus: false,
            renameInput: "",
            dir_id: 0,
            Pagination: {
                total: 0,
                page: 1,
                page_size: 25,
            },
            props: {
                label: "name",
                children: "zones",
                isLeaf: "is_empty",
            },
            folderTree: {},
            uploadPsdStatus: false,
            selectVal: "", // el-select xuanze
            options: [
                { label: "所有素材", value: "", icon: "" },
                {
                    label: "版权素材",
                    value: "copyright",
                    icon: "iconfont icon-Copyright-material",
                },
            ],
            uploadAuto: true,
            name: "materialfile",
            progresscolor: "#FFF",
            uploadLocalVisiable: false,
            accept: ".jpg,.png,.jpeg,.JPG,.PNG,.JPEG",
            showFileList: [],
            uploaddata: {},
            postAction: "api/teamwork/team/materials/upload",
            headers:{}
        };
    },
    computed: {
        loginInfo() {
            return this.$store.getters.loginInfo;
        },
        uploaded() {
            if (this.showFileList.length == 0) {
                return true;
            }
            if (this.$refs.upload && this.$refs.upload.uploaded) {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        if(this.$route.query.folder) {
            this.dir_id = parseInt(this.$route.query.folder.split('_')[1]);
        }
        this.getData();
    },
    watch: {
        $route(val,old){
            this.dir_id = val.query.folder ? parseInt(val.query.folder.split('_')[1]) : 0;
            if(this.dir_id == 0) {
                this.breadList = [];
            }
            this.getData();
        }
    },
    mounted() {
        this.uploaddata = {
            team_id: this.loginInfo.current_team_id,
            type: "style",
            dir_id: this.dir_id,
        };
        let access_token = tokenFunc.getToken();
        if (access_token) {
            this.headers["token"] = `Bearer ${access_token}`;
            this.headers["Authorization"] = `Bearer ${access_token}`;
        }
        // let token = localStorage.authorization ?  JSON.parse(localStorage.authorization) : "";
        // if (token) {
        //     this.headers["token"] = `Bearer ${token.access_token}`;
        //      this.headers["Authorization"] = `Bearer ${token.access_token}`;
        // }
    },
    methods: {
        getData(
            data = {
                act: this.selectVal,
                dir_id: this.dir_id,
                page_size: this.Pagination.page_size,
                page: this.Pagination.page,
            }
        ) {
            Materials.getData(data).then((res) => {
                if (res.data.id) {
                    if(this.$route.query.folder && this.$route.query.folder.split('_')[1] == res.data.current_team.current_dir_id) {
                        this.breadList = [{name: res.data.current_team.dir_name, id: res.data.current_team.current_dir_id}]
                    }
                    this.templateInfo = res.data.current_team;
                    this.Pagination.total = res.data.current_team.styles.total;
                    let styles = this.templateInfo.styles;
                    if (styles.total > 0) {
                        if (styles.data.length == 0 && styles.current_page > 1)
                            this.getData({
                                // act: this.selectVal,
                                dir_id: this.dir_id,
                                page_size: this.Pagination.page_size,
                                page: styles.current_page - 1,
                            });
                    }
                }
            });
        },
        imgError(item) {
            item.url = item.url.split("?")[0];
        },
        changeSelect() {
            this.getData();
        },
        renameClick() {
            let res = this.expireHandle();
            if(res){
                this.renameStatus = true;
                this.moreStatus = false;
            }
        },
        moreShow(item) {
            this.moreInfo = item;
            this.renameInput = item.name;
            this.moreStatus = !this.moreStatus;
        },
        hideMore() {
            // this.moreInfo = null;
            this.moreStatus = false;
        },
        editFolder() {
            let rename = this.$refs.renameDialog.renameObj.renameInput;
            if (this.moreInfo && this.moreInfo.id) {
                if (this.moreInfo.url) {
                    // 存在图片代表是psd格式  修改图片信息
                    Materials.rename(
                        {
                            resource_id: this.moreInfo.id,
                            rename,
                        },
                    ).then((res) => {
                        if (res.status == 1) {
                            this.$message.success("修改成功");
                            this.moreInfo = null;
                            this.renameInput = "";
                            this.renameStatus = false;
                            this.getData();
                        }
                    });
                } else {
                    // 修改文件夹信息
                    Materials.renameDirectory(
                        {
                            team_id: this.loginInfo.current_team_id,
                            rename,
                            dir_id: this.moreInfo.id,
                        },
                    ).then((res) => {
                        if (res.status === 1) {
                            this.$message.success("修改成功");
                            this.moreInfo = null;
                            this.renameInput = "";
                            this.renameStatus = false;
                            this.getData();
                        }
                    });
                }
            } else {
                // const fromData = new FormData();
                // 新建文件夹
                Materials.createDirectory(
                    {
                        team_id: this.loginInfo.current_team_id,
                        dir_name: rename,
                        dir_id: this.dir_id,
                    },
                ).then((res) => {
                    if (res.status == 1) {
                        this.$message.success("新增成功");
                        this.moreInfo = null;
                        this.renameInput = "";
                        this.renameStatus = false;
                        this.getData();
                    }
                });
            }
        },
        newFolder() {
            let res = this.expireHandle();
            if (res) {
                this.renameStatus = true;
                this.renameInput = "";
                this.moreInfo = null;
            }
        },
        collect(item) {
            Template.collect({ team_template_id: item.id }).then((res) => {
                if (res.status === 1) {
                    this.$message.success("收藏成功");
                }
            });
        },
        moveTemp() {
            // 点击移动按钮
            let res = this.expireHandle();
            if(res){
                this.moveDialogStatus = true;
                this.moreStatus = false;
                this.$nextTick(()=>{
                    let node = this.$refs.move.$refs.tree.getNode(0)
                    node.loaded = false
                    node.expand()
                })
            }
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                return resolve([{ name: "全部", id: 0 }]);
            }
            if (node.level > 1) {
                let dir_id = node.data.id;

                Materials.directory(
                    {
                        team_id: this.templateInfo.id,
                        dir_id,
                    },
                ).then((res) => {
                    resolve(res.data);
                });
            }
            if (node.level === 1) {
                // 二级节点

                Materials.directory(
                    {
                        team_id: this.templateInfo.id,
                        dir_id: 0,
                    },
                ).then((res) => {
                    resolve(res.data);
                });
            }
        },
        moveTreeClick(data) {
            // 弹出框打开
            this.folderTree = data;
        },
        psdClose() {
            this.uploadPsdStatus = false;
        },
        moveSubmit() {
            Materials.move({
                resource_id: this.moreInfo.id,
                dir_id: this.folderTree.id,
            }).then((res) => {
                if (res.status === 1) {
                    this.$message.success(res.message);
                    this.moveDialogStatus = false;
                    this.getData();
                }
            });
        },
        closeMove() {
            this.moveDialogStatus = false;
        },
        removeDialogOpen() {
            let res = this.expireHandle();
            if(res){
                this.removeDialogStatus = true;
                this.moreStatus = false;
            }
        },
        removeFolder() {
            if (Object.keys(this.moreInfo).includes("url")) {
                Materials.delete({
                    team_id: this.moreInfo.team_id,
                    resource_id: this.moreInfo.id,
                }).then((res) => {
                    if (res.status === 1) {
                        this.$message.success("删除成功");
                        this.moreInfo = null;
                        this.removeDialogStatus = false;
                        this.getData();
                    }
                });
            } else {
                // 修改文件夹信息
                Materials.deleteDirectory(
                    {
                        team_id: this.moreInfo.team_id,
                        dir_id: this.moreInfo.id,
                    },
                ).then((res) => {
                    if (res.status === 1) {
                        this.$message.success("删除成功");
                        this.moreInfo = null;
                        this.removeDialogStatus = false;
                        this.getData();
                    }
                });
            }
        },

        goDetail(item) {
            // 进入文件夹详情
            if (item === 0) {
                this.dir_id = item;
                this.breadList = [];
                this.getData({ act: this.selectVal, dir_id: 0, per_page: 25, page: 1 });
            } else {
                let index = null;
                for (let i = 0; i < this.breadList.length; i++) {
                    if (this.breadList[i].id === item.id) {
                        index = i;
                    }
                }
                if (index === null) {
                    this.breadList.push(item);
                } else {
                    this.breadList.splice(index + 1, this.breadList.length);
                }
                this.dir_id = item.id;
                this.getData({
                    act: this.selectVal,
                    dir_id: item.id,
                    per_page: 25,
                    page: 1,
                });
            }
        },
        uploadPsdOpen() {
            let res = this.expireHandle();
            if (res) {
                this.uploadPsdStatus = true;
            }
        },
        showuploaddialog() {
            this.uploadLocalVisiable = true;
            this.uploaddata = {
                team_id: this.loginInfo.current_team_id,
                type: "style",
                dir_id: this.dir_id,
            };
        },
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // 添加文件
                if (!/\.(png|jpg|jpeg|PNG|JPG|JPEG)$/i.test(newFile.name)) {
                    this.$message.warning('不支持此文件类型，请选择JPG、PNG、JPEG类型图片上传！')
                    return prevent();
                }

                newFile.upload_step = 1;
                newFile.upload_status = 0;
                newFile.preview_url = this.getObjectURL(newFile.file);
            }

            // 更新文件
            if (newFile && oldFile) {
                // 开始上传
                if (newFile.active !== oldFile.active) {
                    console.log("Start upload");

                    //2为上传中
                    newFile.upload_step = 2;
                }

                // 上传进度
                if (newFile.progress !== oldFile.progress) {
                    newFile.upload_status = 2;
                    newFile.upload_step = 2;
                }

                // 上传错误  这种情况一般是接口出错
                if (newFile.error !== oldFile.error) {
                    newFile.upload_status = 5;

                    //3为上传结束

                    newFile.upload_step = 3;
                    newFile.maskshow = false;
                }

                // 上传成功  根据接口实际情况来判断
                if (newFile.success !== oldFile.success) {
                    //接口的status为1  实际为成功
                    if (newFile.success && newFile.response.status == 1) {
                        newFile.upload_status = 4;
                        newFile.upload_step = 3;
                    }
                    //接口的status为0 实际为失败
                    if (newFile.success && newFile.response.status == 0) {
                        newFile.upload_status = 3;
                        newFile.upload_step = 3;
                        newFile.maskshow = false;
                        this.upload_fail++;
                    }
                    //3为上传结束

                    console.log("success");
                }
            }
        },

        // add, update, remove File Event
        inputFile(newFile, oldFile) {
            if (newFile && !oldFile) {
                this.showuploadtool = false;

                // 添加文件
                newFile.upload_status = 0;

                //1为等待上传
                newFile.upload_step = 1;
            }

            // 更新文件
            if (newFile && oldFile) {
                // 开始上传
                if (newFile.active !== oldFile.active) {
                    console.log("Start upload");

                    //2为上传中
                    newFile.upload_step = 2;
                }

                // 上传进度
                if (newFile.progress !== oldFile.progress) {
                    newFile.upload_status = 2;
                    newFile.upload_step = 2;
                }

                // 上传错误  这种情况一般是接口出错
                if (newFile.error !== oldFile.error) {
                    newFile.upload_status = 5;

                    //3为上传结束

                    newFile.upload_step = 3;
                    newFile.maskshow = false;
                }

                // 上传成功  根据接口实际情况来判断
                if (newFile.success !== oldFile.success) {
                    //接口的status为1  实际为成功
                    if (newFile.success && newFile.response.status == 1) {
                        newFile.upload_status = 4;
                        newFile.upload_step = 3;
                        // let params = { file:newFile.file }
                        // this.staticFunc.uploadImgRes(params, newFile.response, res=>{
                        //     let uParams = {
                        //         team_id: newFile.data.team_id,
                        //         type: "style",
                        //         dir_id: newFile.data.dir_id,
                        //         file:newFile.file
                        //     }
                        //     Materials.upload(uParams).then(result=>{
                        //         console.log(result)
                        //     })
                        // })
                    }
                    //接口的status为0 实际为失败
                    if (newFile.success && newFile.response.status == 0) {
                        newFile.upload_status = 3;
                        newFile.upload_step = 3;
                        newFile.maskshow = false;
                        //Vue.prototype.$message.error(response.error);
                    }
                    //3为上传结束

                    console.log("success");
                }
            }

            // 自动上传
            if (
                Boolean(newFile) !== Boolean(oldFile) ||
                oldFile.error !== newFile.error
            ) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true;
                    this.showuploadtool = false;
                }
            }
        },

        fontmouseover(file, index) {
            if(!this.showFileList[index]) {
                return 
            }
            file.maskshow = true;
            this.$set(this.showFileList, index, file);
        },
        fontmouseout(file, index) {
            if(!this.showFileList[index]) {
                return 
            }
            file.maskshow = false;
            this.$set(this.showFileList, index, file);
        },
        stopUpload() {
            let _this = this;
            if (this.showFileList.length > 0) {
                this.showFileList.forEach((value) => {
                    //停止上传请求并删除对应文件
                    _this.$refs.upload.update(value, { error: "abort" });
                });
                _this.$refs.upload.clear();
            }

            //关闭上传弹框
            this.uploadLocalVisiable = false;
            this.getData();
        },
        uploadLocalconfirm() {
            this.uploadLocalVisiable = false;
            this.getData();
        },
        uploadLocalcancle() {
            //this.uploadLocalVisiable = false;
            //this.$refs.uploadfontdialog.close();
            if (this.showFileList.length == 0) {
                this.uploadLocalVisiable = false;
            }

            if (this.showFileList.length > 0) {
                var isTip = false;
                this.showFileList.forEach((value) => {
                    if (
                        (!value.active && !value.success) ||
                        value.progress != "0.00" ||
                        value.upload_step == 1 ||
                        value.upload_step == 2
                    ) {
                        isTip = true;
                    }
                });

                if (isTip) {
                    //取消后未成功的需要重新上传，是否取消？
                    this.uploadCancelDialogStatus = true;
                }
            }
        },
        uploadbeforeclose(done) {
            //判断当前是否有上传内容
            if (this.showFileList.length == 0) {
                done();
            }

            if (this.showFileList.length > 0) {
                var isTip = false;
                this.showFileList.forEach((value) => {
                    if (
                        (!value.active && !value.success) ||
                        value.progress != "0.00" ||
                        value.upload_step == 1 ||
                        value.upload_step == 2
                    ) {
                        isTip = true;
                    }
                });

                if (isTip) {
                    //取消后未成功的需要重新上传，是否取消？
                    this.uploadCancelDialogStatus = true;
                    return false;
                }
            }
        },
        openuploadtool() {
            this.showuploadtool = true;
            this.showFileList = [];
        },
        getObjectURL(file) {
            var url = null;
            if (window.createObjectURL != undefined) {
                // basic
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) {
                // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            }
            return url;

            /*  var _this = this;
              let reader = new FileReader();
              //新建 FileReader 对象
              reader.onload = function(){
                // 当 FileReader 读取文件时候，读取的结果会放在 FileReader.result 属性中
                file.preview_url = reader.result;
                _this.$set(_this.showFileList,)
              };
              // 设置以什么方式读取文件，这里以base64方式
            reader.readAsDataURL(file.file);
            file.reader = reader;
            return file */
        },
        deluploadfile(file) {
            console.log(file.reader);

            if (file.reader && file.reader.abort) {
                console.log("停止缩略图生成");
                file.result = null;
                file.reader.abort();
            }
            this.$refs.upload.update(file, { error: "abort" });
            this.$refs.upload.remove(file);
            if (this.showFileList.length <= 0) {
                this.showuploadtool = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep( .upload-localfont-dialog) {
    @include dialog-525(744px, 610px, 60px);
    .el-dialog__body {
        height: 440px;
        padding-left: 40px;
        width: calc(100% - 26px);
        overflow-y: auto;
        overflow-x: hidden;
        @include prefixer(box-sizing, border-box);
        .upload-localfont-title {
            span {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3c3c43;
                line-height: 22px;
            }
        }

        .errorinfo-alert {
            height: 32px;
            padding: 6px 12px;
            margin-top: 8px;
            background: rgba(229, 75, 75, 0.1);
            @include prefixer(box-sizing, border-box);

            .el-alert__content {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3c3c43;
            }
        }

        #upload-section {
            @include flexble();
            width: 100%;
            height: 150px;
            cursor: pointer;
            .upload-component {
                @include flexble();
                .el-upload,
                .el-upload--picture-card {
                    width: 150px;
                    height: 150px;
                    line-height: 150px;
                    background: #f3f3f3;
                    border-radius: 6px;
                    border: none;
                    @include flex();
                    @include justify-content(center);
                    @include align-item(center);
                    i {
                        font-size: 44px;
                        color: #aaaab1;
                    }
                }
                .el-upload-list,
                .el-upload-list--picture-card {
                    @include flex();
                    @include flex-wrap(wrap);
                    .el-upload-list__item {
                        width: 150px;
                        height: 150px;
                        border: 1px solid #e7e7e7;
                        margin: 0;
                        padding: 0;
                        margin-left: 16px;
                    }
                }
            }

            i {
                font-size: 57px;
                color: #aaaab1;
            }
        }

        .upload-list-box {
            margin-top: 30px;
            @include flexble();
            @include flex-wrap(wrap);
            li {
                width: 150px;
                height: 178px;
                position: relative;
                margin-right: 16px;
                margin-bottom: 16px;
                cursor: default;
                .state-box {
                    position: relative;
                    width: 150px;
                    height: 150px;
                    /*  background: rgba(0,0,0,.6); */

                    @include prefixer(box-sizing, border-box);
                    @include prefixer(border-radius, 6px);
                    @include flexble();
                    @include justify-content(center);
                    @include align-item(center);
                    img {
                        object-fit: scale-down;
                        width: 100%;
                        height: 100%;
                    }
                    img.img_path {
                        width: 100%;
                        height: 100%;
                    }
                }

                .upload-listitem-actions {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    cursor: default;
                    text-align: center;
                    font-size: 6px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 9px;
                    background-color: rgba(0, 0, 0, 0.6);
                    @include prefixer(border-radius, 6px);
                    @include flexble();
                    @include justify-content(center);
                    @include align-item(center);
                    .el-progress {
                        width: 80px;

                        .el-progress-bar {
                            padding-right: 0;
                            margin-right: 0;
                            .el-progress-bar__outer {
                                background-color: #b2b2b2;
                            }
                        }
                    }

                    .tryagain-btn {
                        &.el-button {
                            border-radius: 6px;
                            line-height: 16px;
                            border: 1px solid #fff;
                            color: #fff;
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            background-color: transparent;
                            padding: 3px 15px;
                        }
                    }

                    .upload-fail-icon {
                        width: 16px;
                        height: 16px;
                        margin-bottom: 7px;
                    }
                    .upload-delete-icon {
                        width: 18px;
                        height: 18px;
                        cursor: pointer;
                        position: absolute;
                        top: -9px;
                        right: -9px;
                        z-index: 10;
                    }
                    .upload-fail-tiptext {
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: #ffffff;
                        line-height: 16px;
                        width: 90%;
                    }

                    &.upload-listitem-actions-tip {
                        @include flex-direction(column);
                    }
                }
                .state-box-border {
                    border: 1px solid #e7e7e7;
                }
                .upload-lsititem-title {
                    margin-top: 8px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3c3c43;
                    line-height: 17px;
                    text-align: center;
                    @include text-ellipsis();
                }
                &:nth-of-type(4n + 1) {
                    margin-right: 0;
                }
            }
            .fileitem:nth-of-type(4n + 1) {
                margin-right: 0;
            }
        }

        &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        }
        &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 8px;
            background: #3c3c43;
        }
    }

    .el-dialog__footer {
        padding: 0;
        .btn-wrap {
            margin-top: 20px;
            @include justify-content(center);
            button {
                width: 110px;
                height: 40px;
                margin-right: 48px;
                &:nth-last-of-type(1) {
                    margin-right: 0;
                }
            }
        }
    }
}

::v-deep(.file-uploads) {
    width: 150px;
    height: 150px;
    background: #f3f3f3;
    border-radius: 6px;
    cursor: pointer;
    @include prefixer(box-sizing, border-box);
    @include flexble();
    @include justify-content(center);
    @include align-item(center);

    &.file-uploads-html5 label {
        cursor: pointer;
    }
}

.template {
    padding: 0 24px;
    // .bread {
    //   cursor: pointer;
    //   font-size: 13px;
    //   font-weight: 400;
    //   height: 52px;
    //   line-height: 52px;
    //   color: #2d2d32;
    //   ul {
    //     display: flex;
    //     .purple-active {
    //       color: #7966fe;
    //       .iconfont {
    //         color: #7966fe;
    //       }
    //     }
    //   }
    // }
}
.folder-ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}

.image-ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  ::v-deep( .image-d) {
    background-image: linear-gradient(to top right, #f4f4f4 25%, transparent 0, transparent 75%, #f4f4f4 0, #f4f4f4),linear-gradient(to top right, #f4f4f4 25%, transparent 0, transparent 75%, #f4f4f4 0, #f4f4f4);
    background-position: 0 0,6px 6px;
    background-size: 12px 12px;
  }
}
.move-main {
    width: 440px;
    height: 302px;
    border: 1px solid #e1e1e1;
    margin: 0 auto;
    padding-top: 16px;
    padding-bottom: 11px;
    padding-right: 8px;
    overflow: hidden;
    border-radius: 8px;
}
</style>
